import axios from './index';

export const sendMsgAPI = async (data) => {
  try {
    const result = await axios({
      method: 'post',
      url: `/careers/contact-us`,
      data,
    });
    return result?.data;
  } catch (ex) {
    console.log(ex);
    return {};
  }
};
